import { FC } from "react";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles(() => ({
  status: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 3,
    borderRadius: 4,
  },
  point: {
    display: "inline-block",
    width: 4,
    height: 4,
    borderRadius: "50%",
    marginRight: 4,
  },
  statusValue: {
    fontSize: 10,
    fontWeight: "bold",
    textTransform: "uppercase",
  },
}));

interface ConciergeStatusLabelProps {
  type: "Active" | "Expired" | "Not Started" | "No" | "Modified";
}

const ConciergeStatusLabel: FC<ConciergeStatusLabelProps> = ({ type }) => {
  const classes = useStyles();
  const labelStyle = {
    Active: { color: "#00AB50", bgColor: "rgba(0, 171, 80, 0.2)" },
    Expired: { color: "#898989", bgColor: "#DEDEDE" },
    "Not Started": { color: "#FC9D03", bgColor: "#FFECC2" },
    No: { color: "#FF5F58", bgColor: "#FFE1D9" },
    Modified: { color: "#643ABD", bgColor: "rgba(100, 58, 189, 0.2)" },
  };

  return (
    <div
      className={classes.status}
      style={{
        background: labelStyle[type].bgColor,
      }}
    >
      <span
        className={classes.point}
        style={{
          background: labelStyle[type].color,
        }}
      ></span>
      <span
        className={classes.statusValue}
        style={{
          color: labelStyle[type].color,
        }}
      >
        {type}
      </span>
    </div>
  );
};

export default ConciergeStatusLabel;
